/**
 * Utilidades para probar el modo académico sin necesidad de Apolearn
 * Solo para desarrollo/testing
 */

import academicService from '../services/academicService';
import { authService } from '../services/authService';

/**
 * Activar modo académico de prueba (sin Apolearn)
 * Usar desde la consola del navegador: window.enableTestAcademicMode()
 */
export function enableTestAcademicMode() {
  if (typeof window === 'undefined') return;

  (window as any).enableTestAcademicMode = () => {
    
    // Simular que getUserAcademicLevel retorna A1.1
    const originalGetUserAcademicLevel = academicService.getUserAcademicLevel;
    academicService.getUserAcademicLevel = async () => {
      return { level: 'A1.1', unit: 0, lesson: 1 };
    };

    
    return {
      level: 'A1.1',
      unit: 0,
      lesson: 1,
      restore: () => {
        academicService.getUserAcademicLevel = originalGetUserAcademicLevel;
      }
    };
  };

  /**
   * SIMULAR DATOS DE APOLEARN CON NIVEL A1.1
   * 
   * Esta función simula que el usuario obtuvo el nivel A1.1 de Apolearn por primera vez.
   * Los datos se guardan en memoria en `authService.apolearnUserData`.
   * 
   * Para usar desde la consola:
   *   window.simulateApolearnA1_1('tu-email@ejemplo.com')
   * 
   * Para borrar los datos simulados:
   *   window.clearSimulatedApolearn()
   * 
   * IMPORTANTE: 
   * - Los datos solo existen en memoria durante la sesión del navegador
   * - Si recargas la página, los datos simulados se perderán
   * - Los datos se guardan en: authService.apolearnUserData
   * - Para borrarlos: authService.clearSimulatedApolearnData()
   */
  (window as any).simulateApolearnA1_1 = (
    email: string = 'test@example.com',
    firstName: string = 'Test',
    lastName: string = 'User'
  ) => {
    
    try {
      authService.simulateApolearnA1_1(email, firstName, lastName);
    } catch (error) {console.error('❌ Error al simular datos de Apolearn:', error);
      return;
    }
    
    
    // Verificar que los datos se guardaron correctamente
    const data = authService.getApolearnUserData();
  };

  /**
   * BORRAR DATOS SIMULADOS DE APOLEARN
   * 
   * Esta función borra los datos simulados de Apolearn que se crearon con
   * `simulateApolearnA1_1()`.
   * 
   * Los datos se guardan en memoria en `authService.apolearnUserData`.
   * Al llamar esta función, se establece `authService.apolearnUserData = null`.
   * 
   * Para usar desde la consola:
   *   window.clearSimulatedApolearn()
   * 
   * IMPORTANTE: 
   * - Si los datos son reales (no simulados), esta función también los borrará
   * - Los datos solo se borran de memoria, no afecta datos en Apolearn
   * - Si recargas la página, los datos simulados se perderán de todas formas
   */
  (window as any).clearSimulatedApolearn = () => {
    
    const hadData = authService.getApolearnUserData() !== null;
    authService.clearSimulatedApolearnData();
    
    if (hadData) {
    } else {
    }
  };

}

